// Resolves the app URL for sign-in / sign-up CTAs: the stage's own app (sst.config passes the stage
// env through, and NEXT_PUBLIC_ROOT_DOMAIN_URL_FULL is the app's full URL its emails link to), so a
// test-stage site never signs people up on production. The fallback is the Canadian app, where the
// old refdocs.com sent every visitor; its /signin and /try offer the U.S. app to U.S. visitors.
const fallbackAppUrl = "https://app.refdocs.ca";

function appUrl() {
  return process.env.NEXT_PUBLIC_APP_URL || process.env.NEXT_PUBLIC_ROOT_DOMAIN_URL_FULL || fallbackAppUrl;
}

export const links = {
  signin: () => `${appUrl()}/signin`,
  trial: () => `${appUrl()}/try?plan=specialist`,
  // The app has no self-serve free plan: /try only offers the paid Specialist checkout, and a free
  // Resident office is set up by Refdocs. So the Resident CTA goes to the contact form.
  resident: () => "/contact?topic=resident",
  contactSales: () => "/contact?topic=enterprise",
  trustCentre: () => "https://trust.refdocs.com",
};
